export const authErrorCode = (error: unknown): string =>
  typeof error === 'object' && error !== null && 'code' in error
    ? String(error.code)
    : '';

export const isExpiredAuthSession = (error: unknown): boolean =>
  [
    'auth/user-token-expired',
    'auth/invalid-user-token',
    'auth/user-disabled',
    'auth/user-not-found',
  ].includes(authErrorCode(error));

export const authErrorMessage = (error: unknown): string => {
  switch (authErrorCode(error)) {
    case 'auth/email-already-in-use':
      return 'This email is already registered. Sign in instead.';
    case 'auth/invalid-email':
      return 'Enter a valid email address.';
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
      return 'The email or password is incorrect.';
    case 'auth/weak-password':
      return 'Choose a stronger password.';
    case 'auth/operation-not-allowed':
      return 'This sign-in method is currently unavailable.';
    case 'auth/popup-closed-by-user':
      return 'Google sign-in was cancelled.';
    case 'auth/popup-blocked':
      return 'The Google sign-in window was blocked. Allow popups and try again.';
    case 'auth/account-exists-with-different-credential':
      return 'An account already uses this email. Sign in with email and password, then connect Google from the account menu.';
    case 'auth/unauthorized-domain':
      return 'Google sign-in is not configured for this app domain.';
    case 'auth/network-request-failed':
      return 'The network request failed. Check your connection and try again.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Wait a little before trying again.';
    case 'auth/user-disabled':
      return 'This account has been disabled.';
    case 'auth/user-token-expired':
    case 'auth/invalid-user-token':
      return 'Your session expired. Sign in again to continue. Any completed changes are saved.';
    case 'auth/requires-recent-login':
      return 'Sign out and sign in again before changing this account.';
    case 'auth/credential-already-in-use':
      return 'That Google account is already connected to another qkIndex account.';
    default:
      return 'Authentication failed. Please try again.';
  }
};
